import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-96c43f80"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["data-href"];
const _hoisted_2 = {
    class: "list-group-item p-0 pt-3",
    "data-products-id": " PRODUCT_ID "
};
const _hoisted_3 = { class: "d-flex px-3" };
const _hoisted_4 = { class: "col-3 px-0 mb-4 mr-2" };
const _hoisted_5 = ["href"];
const _hoisted_6 = ["src"];
const _hoisted_7 = ["href"];
const _hoisted_8 = { class: "flex-grow-1 mb-4 mr-2" };
const _hoisted_9 = { class: "productsname h6 strong mb-0" };
const _hoisted_10 = { class: "products_prop font7-responsive mb-0" };
const _hoisted_11 = { class: "strong" };
const _hoisted_12 = { class: "productsnummer font7-responsive" };
const _hoisted_13 = { class: "productsprice font6-responsive strong" };
const _hoisted_14 = { class: "mb-4" };
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "icon-minus-circled h6" }, null, -1));
const _hoisted_16 = [
    _hoisted_15
];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_formatted_price = _resolveComponent("formatted-price");
    return (_openBlock(), _createElementBlock("div", {
        class: "list-group list-group-flush pointerhover",
        "data-href": '/kaufen/info/' + _ctx.cartItem.name + '__' + _ctx.cartItem.id
    }, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("a", {
                        href: '/kaufen/info/' + _ctx.cartItem.name + '__' + _ctx.cartItem.id,
                        title: "zum Produkt"
                    }, [
                        _createElementVNode("img", {
                            src: _ctx.cartItem.image,
                            class: "img-fluid maxh-6 mx-auto d-block",
                            alt: "Produktabbildung"
                        }, null, 8, _hoisted_6)
                    ], 8, _hoisted_5)
                ]),
                _createElementVNode("a", {
                    href: '/kaufen/info/' + _ctx.cartItem.name + '__' + _ctx.cartItem.id,
                    title: "zum Produkt"
                }, [
                    _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.cartItem.name), 1),
                        _createElementVNode("div", _hoisted_10, [
                            _createTextVNode(" Zustand: "),
                            _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.cartItem.condition), 1)
                        ]),
                        _createElementVNode("div", _hoisted_12, "Artikelnummer: " + _toDisplayString(_ctx.cartItem.cArtNr), 1),
                        _createElementVNode("div", _hoisted_13, [
                            _createTextVNode(_toDisplayString(_ctx.cartItem.quantity) + "x ", 1),
                            _createVNode(_component_formatted_price, { price: _ctx.price }, null, 8, ["price"])
                        ])
                    ])
                ], 8, _hoisted_7),
                _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("button", {
                        type: "button",
                        class: "close h7",
                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.removeProduct()))
                    }, _hoisted_16)
                ])
            ])
        ])
    ], 8, _hoisted_1));
}
